<template>
  <div class="about">
    <h1>This is an location page</h1>
  </div>
</template>
